import styled from "@emotion/styled";
import type { CSSObject } from "@emotion/react";
import TextField from "@mui/material/TextField";
import { cvar } from "styles";

export const InputContainer = styled("div")(
  (): CSSObject => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  }),
);

export const LabelGroupWrapper = styled("div")(
  (): CSSObject => ({
    display: "flex",
    flexDirection: "column",
    height: "20px",
  }),
);

export const StyledFormLabel = styled("div")(() => ({
  fontSize: "10px",
  fontWeight: "600",
  lineHeight: "9px",
  marginBottom: "8px",
  color: cvar("nepal-blue"),
  textTransform: "uppercase",
}));

export const StyledTextField = styled(TextField)(
  (): CSSObject => ({
    marginBottom: "12px",
    "& .MuiOutlinedInput-root": {
      "& > fieldset": { borderColor: cvar("botticelli-blue") },
      "&.Mui-focused fieldset": {
        borderColor: cvar("botticelli-blue"),
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: `${cvar("botticelli-blue")} !important`,
    },
    "& input[type=number]": {
      MozAppearance: "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  }),
);
